/* 
*  Copyright (c) Intel Corporation.  All Rights Reserved.
*
*/
// IMPORTANT: DO NOT ADD ANY DEPENDENCY ON engine.js HERE

// The main purpose here is to pre-declare the objects that we know about
// so that we can push updated scripts that reassign those that need changing.
// These definitions should be 'null' initially, and we will import known scripts that will
// properly define them.
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { ModuleManager , _factoryManager, globalEngine, enableAnalyticsSDKForUWP} from "./Init";
import { LoadScript, getMessageBus, getScriptVariableStore, getPluginFactory, queryGeoInfoUWP, GetProperty, GetSetting } from "./bootstrap_web_ext"
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";
import { engine } from "./engine"

// #ENDIF WebPack
if (typeof JSON !== "object")
{
    LoadScript("json2.js");
}

//Flag for checking if we are in UWP application
if(typeof enableAnalyticsSDKForUWP === "undefined")
{
     enableAnalyticsSDKForUWP = false;
}

// NOTE: logging.js is deferred until AFTER the GetEngineProperties() function declaration in order 
//       that we can check a registry setting to enable debugging output at runtime.

// define an engine-specific version of the 'GetSettings' function; for SDK 2.2 or earlier we don't have
// a 'GetSetting' so we compensate thusly.
var GetEngineSetting = function(name, defaultValue)
{
    return defaultValue;
}
if (typeof GetSetting === 'function')
{
    // remap the 'engine' settings function to use the global one
    GetEngineSetting = GetSetting;
}
else // using the default
{
    logInformation("Missing GetSetting function; will only use default settings (this is expected pre SDK.2.3)");
}

// define an engine-specific version of the 'GetProperty' function; for SDK 2.4 or earlier we don't have
// a 'GetProperty' so we compensate thusly.
var GetEngineProperty = function (name, defaultValue)
{
    return defaultValue;
}
if (typeof GetProperty === 'function')
{
    // remap the 'engine' Property function to use the global one
    GetEngineProperty = GetProperty;
}
else // using the default
{
    logInformation("Missing GetProperty function; will only use default Properties (this is expected pre SDK.2.5)");
}
// NOTE: logging is deferred until here because it will use GetEngineProperty()
//       to figure out if debugging has been enabled in the SDK.
if(!enableAnalyticsSDKForUWP)
{
    LoadScript("logging.js");
}



var getSystemPlugin = function()
{
    var systemPlugin = getScriptVariableStore().Get("system");

    if (!systemPlugin) 
    {
        systemPlugin = getPluginFactory().Create("system");
        getScriptVariableStore().Set("system", systemPlugin);
    }
    return systemPlugin;
}



//
// common/global functions
//

////////////////////////////////////////////////////////////////
// Date manipulators start

/* Exposing toISOString prototype
 *  PARAMS:
 *      dateOnly: boolean to request level of details
 *  RETURN:
 *      date in ISO string format YYYY-MM-DD if dateOnly, otherwise: YYYY-MM-DDTHH:MM:SSZ
 */
Date.prototype.toISOString = function (dateOnly)
{
    try
    {
        function pad(number)
        {
            var r = String(number);
            if (r.length === 1)
            {
                r = '0' + r;
            }
            return r;
        };

        var myDate = this.getUTCFullYear()
            + '-' + pad(this.getUTCMonth() + 1)
            + '-' + pad(this.getUTCDate());

        if ( dateOnly )
        {
            return myDate;
        }

        myDate += 'T' + pad(this.getUTCHours())
            + ':' + pad(this.getUTCMinutes())
            + ':' + pad(this.getUTCSeconds())
            + 'Z';

        return myDate;
    }
    catch (e)
    {
        return null;
    }
};

var dateToMfeString = function (date)
{
    try
    {
        function pad(number)
        {
            var r = String(number);
            if (r.length === 1)
            {
                r = '0' + r;
            }
            return r;
        };

        var myDate = date.getUTCFullYear()
            + pad(date.getUTCMonth() + 1)
            + pad(date.getUTCDate());
        return myDate;

    }
    catch (e)
    {
        return null;
    }
};

/* Converts ISO string to a date object - Date.Parse does not exist in some versions of JS9
 *  PARAMS:
 *      value: string to convert
 *  RETURN:
 *      date object i
 */
function isoDateToDate(value)
{
    try
    {
        if (!value || (8 > value.length))
        {
            return null;
        }

        var year = parseInt(value.substr(0, 4), 10);
        var month = parseInt(value.substr(5, 2), 10);
        var day = parseInt(value.substr(8, 2), 10);
        var hour = parseInt(value.substr(11, 2), 10);
        var minute = parseInt(value.substr(14, 2), 10);
        var second = parseInt(value.substr(17, 2), 10);
        if (!year || !month || !day)
        {
            return null;
        }

        hour    = isNaN(hour)   ? 0 : hour;
        minute  = isNaN(minute) ? 0 : minute;
        second  = isNaN(second) ? 0 : second;

        return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    }
    catch(e)
    {
        logError('isoDateToDate: exception caught with message: ' + e.message);
        return null;
    }
};

// Date manipulators end
////////////////////////////////////////////////////////////////

//For file vers of form x0,x1,x2,x3... => xn E Z+ (natural numbers)
//slits version strings and compare element by element
function isFirstFileVersionGreater(ver1,ver2){

    //sdk without version should return true
    //which might be the case for older sdks
    if (!ver1 || !ver2) {return true;}

    try
    {
        var version1 = ver1.split(',');
        var version2 = ver2.split(',');

        if (version1.length != version2.length) {
            logError("isFirstFileVersionGreater: Could not compare versions with unequal length");
            return false;
        }
        for (var index in version1){
            var versNum1 = parseInt(version1[index], 10); 
            var versNum2 = parseInt(version2[index], 10); 

            if(isNaN(versNum1) || isNaN(versNum2))
            {
                logError("isFirstFileVersionGreater: Could not compare non-numerics file versions");
                return false;
            }else if (versNum1 == versNum2)
            {
                continue;
            }
            else if(versNum1 < versNum2)
            {
                return false;
            }else{
                return true;
            }
        }
    }catch(e)
    {
        logError("isFirstFileVersionGreater: Failed due to "+e.message);
    }
    return false;
}

//Find the size of a javascript object
// Object.keys(myObj).length is not supported in jscript9
// We are iteratiing through the object to find the number of elements
function findObjectSize(inObject)
{
    if(!inObject){
        return 0;
    }

    var size = 0;
    for(var key in inObject){
        if (inObject.hasOwnProperty(key)) {
            size+=1;
        }
    }
    return size;
}

////////////////////////////////////////////////////////////////
// Wrappers

if(typeof __wrapMsgBusPlugin !== "function")
{
    function __wrapMsgBusPlugin(plugin)
    {
        // make a basic msgbus plugin wrapper; this will simplify the effort of accounting for new features 
        //   on each version while still maintaining backwards compatibility with older SDK installations.
        // This is effectively a null-implementation in the case that msgbus completely fails to get created
        //   but it will execute plugin functions once we have an actual msgbus in-hand.
        //
        // NOTE: This will have to be updated whenever new public intefaces are added to the
        //       message bus plugin.
        var wrapper =
        {
            // v1
            "GetName": function ()
            {
                return (this.IsAvailable() ? this._plugin.GetName() : "msgbus");
            },
            "GetVersion": function ()
            {
                return String(this._version);
            },
            "Initialize": function (q)
            {
                return (this.IsAvailable() ? this._plugin.Initialize(q) : true);
            },
            "Publish": function (m, p) 
            {
                return (this.IsAvailable() ? this._plugin.Publish(m, p) : true);
            },
            "Subscribe": function (m) 
            {
                return (this.IsAvailable() ? this._plugin.Subscribe(m) : true);
            },
            "Unsubscribe": function (m) 
            {
                return (this.IsAvailable() ? this._plugin.Unsubscribe(m) : true);
            },
            // v2
            "Request": function (m, p) 
            { 
                return ((this.IsAvailable() && (this._version >= 2)) ? this._plugin.Request(m, p) : true);
            },
            // v3
            "IsAvailable": function () 
            {
                // returns false if the underlying plugin is null (just in case)
                // returns true if the underlying plugin is v2 or less (emulates the old assumption)
                // otherwise returns the availability status (which technically should always be true by this point)
                return ((this._plugin && (this._version >= 3 )) ? this._plugin.IsAvailable() : (null != this._plugin));
            },
            "_plugin": plugin,
            "_version": (plugin ? parseInt(plugin.GetVersion(), 10) : 0) // cache version (int) for simplicity in the wrapper functions
        };

        if (!plugin)
        {
            // we shouldn't see this happening, but let's test for it just in case.
            logError("null msgbug plugin, wrapping in a null-implementation");
        }
        return wrapper;
    }

    // Here we replace the getMessageBus function with a new one that always wraps whatever 
    //   msgbus we get in the helper class (above).
    // Note that we don't replace the cache with the wrapped plugin.  Two reasons for this:
    //   1. For v3+ of the plugin we don't cache it in the case that "IsAvailable()" returns false,
    //      so that we keep trying to load the msgbus dll.
    //      (if it gets installed after us we get a chance to actually use it)
    //   2. Because of (1) it is tricky to know when the dlls finally got loaded without adding some 
    //      statefulness into this code, which would be overcomplicated and therefore more risky.
    // We can revisit if we find a performance problem, but constant state-checking may be just as bad.
    var __bootGetMessageBus = globalEngine.getMessageBus; // save the original
    globalEngine.getMessageBus = function() 
    {
        return __wrapMsgBusPlugin(__bootGetMessageBus());
	}
}

// Helper class to join data objects
var dataManipulator =
{
    "mergeAndLowerDictionary": function(dest, source)
    {
        if (!dest || !source)
        {
            return; // quick exit
        }
        for (var index in source)
        {
            dest[index.toLowerCase()] = source[index];
        }
    },
    "mergeDictionary": function (dest, source) {
        if (!dest || !source)
        {
            return; // quick exit
        }
        for (var index in source)
        {
            dest[index] = source[index];
        }
    },
    "arrayRemoveDuplicates": function(source)
    {
        if (typeof source === "Array")
        {
            var dest = source.filter(function (elem, index, self)
            {
                return index == self.indexOf(elem);
            });
            return dest;
        }
        else if (typeof source === "object")
        {
            // assume an object of the format 'foo = [xxx, xxx, xxx...]'
            var dest = [];
            var tmp = {};
            for (var index = 0; index < source.length; ++index)
            {
                tmp[source[index]] = 0;
            }
            for (var elem in tmp)
            {
                dest.push(elem);
            }
            return dest;
        }
        return source; // no idea how to remove duplicates, so we return the original
    }
};

LoadScript("common_manager_utils.js");
// Overwriting getDaSender function to call UnInitialize
globalEngine.getDaSender = function (isUpdate) 
{
    try
    {
        var da_sender = getScriptVariableStore().Get("da");
        if (da_sender)
        {
            if (isUpdate !== true)
            {
                return da_sender;
            }
            //This is an update, we need to restart the DA Plugin
            da_sender.UnInitialize();
            da_sender = null;
            getScriptVariableStore().Set("da", da_sender);
            try { CollectGarbage(true); } catch(e){ };
        }
        da_sender = getPluginFactory().Create("da");
        getScriptVariableStore().Set("da", da_sender);

        return da_sender;
    }
    catch(e)
    {
        logError('getDaSender: Exception caught with message: ' + e.message);
    }
    return null;
}


///
var __geoInfo = 
{
    'queryDate': null,
    'geoid': null,
    'isQA': null,
    'retry': 5,// 2^5 secs
    'maxPeriod':19 // 2^19 secs
}

function getRandTimeBetween(minSec,maxSec)
{
    return Math.floor(Math.random() * (maxSec - minSec + 1) ) + minSec;
}

function isGeoidNumbers(geoid)
{   
        var geoidNumRegExp = /\d+?/g;   
        var isaNumber = geoidNumRegExp.exec(geoid); 
        return isaNumber != null;   
}

function queryGeoInfo()
{
    //Query GeoInfo for Uwp application
    if(enableAnalyticsSDKForUWP)
    {
        return queryGeoInfoUWP();
    }

    var header = null;
    var funcUrl = 'https://prd-mcafee-mosaic-pub.azurewebsites.net/api/geoiplookup?code=rXirGSARC5aMI8vaT2FIgrd9xrI/y2rtWqKNdjmHccR3n8oZEmdkMA==';
    var method = 'GET';
    var re = new RegExp("^2\.4");
    if(re.test(engine.getBootstrapFileVersion()))
    {
        //Using the xmlHttp object
        ModuleManager.create("rest_transport");
        var xmlHttpComObj = ModuleManager.create("xmlHttpComObj");
        xmlHttpComObj.setup();
        xmlHttpComObj.open(method, funcUrl, false);
        var result = xmlHttpComObj.send('');
        header = xmlHttpComObj.getAllResponseHeaders();
    }
    else
    {
        var restPlugin = getPluginFactory().Create("RESTclient");
        restPlugin.SetAgentName('McAfee ALE');
        restPlugin.SetHttpMode(method);
        restPlugin.Connect(funcUrl);
        var response = restPlugin.SendRequest('');
        restPlugin.Disconnect();

        var responseObj = JSON.parse(response);
        header = responseObj['header'];
    }

    return header;
}

function extractGeoInfo(geoInfo)
{
    var header = queryGeoInfo();

    var geoidRegExp = /x-geoid: _(.*?)_/g;
    var match = geoidRegExp.exec(header);
    if (match)
    {
        geoInfo.geoid = match[1];
    }

    var isQARegExp = /x-qae: _(.*?)_/g;
    match = isQARegExp.exec(header);
    if (match)
    {
        geoInfo.isQA = match[1];
    }
    geoInfo.retry = geoInfo.retry +1;

    //cap the power (retry ) and reset if max
    if(geoInfo.retry >= geoInfo.maxPeriod)
    {
        geoInfo.retry = 5; //reset retry to about a minutes time
    }
}

/*
    Changed the try back time to be exponential. Current implementation starts with 2^5 secs (0 mins) 
    back off time and max of 2^19 secs (6 days). Back off times 0,1,1,2,4,9,17,24,68,137,273,546,1092,2185,4369,8738 mins
    @retry: power of 2
    @maxPeriod: 19 i.e. 2^19 secs (6 days)
*/
function getGeoInfo()
{
    try
    {
        var geoInfoKey = "analytics.geoInfo";

        // Reduce calls to msg bus by checking for the value locally first
        var geoInfo = __geoInfo ;
        if(!geoInfo.queryDate)
        {
            var geoInfoStr = globalEngine.RegistryStore.get(geoInfoKey);
            if(geoInfoStr) {
             geoInfo = JSON.parse(geoInfoStr);
            }

        }

        if(!geoInfo.retry || (typeof(geoInfo.retry) != "number")){
            geoInfo.retry = 5 ; //about a minutes time
        }

        if(!geoInfo.maxPeriod || (typeof(geoInfo.maxPeriod) != "number")){
            geoInfo.maxPeriod = 19 ; //about 6 days time
        }

        var operations = ModuleManager.getSingleton("operations");

        var nextRetryTimeSeconds = Math.pow(2,geoInfo.retry); 
        var minPeriodSeconds = Math.pow(2,4); //2^4 (16) secs
        //Backoff time always random between 16 secs and 2^retry secs, retry increases linearly up to geoInfo.maxPeriod
        var nextRandomRetryTimeMinutes =  Math.floor(getRandTimeBetween(minPeriodSeconds,nextRetryTimeSeconds)/60);

        var geoidIsNotNullandGeoidNotExpired  = geoInfo.queryDate && (isGeoidNumbers(geoInfo.geoid) && (operations.timeSince(isoDateToDate(geoInfo.queryDate),"days") < 7));
        var backoffTimeNotExpired = geoInfo.queryDate && (operations.timeSince(isoDateToDate(geoInfo.queryDate),"minutes") < nextRandomRetryTimeMinutes);
        
        // If we got the geoid, update in 7 days else back off exponentially
        if ( geoidIsNotNullandGeoidNotExpired || backoffTimeNotExpired)
        {
            logDebug('getGeoInfo: Geoid not expired: Geoinfo: ' +JSON.stringify(geoInfo)+" nextRandomRetryTimeMinutes: "+nextRandomRetryTimeMinutes);
            return geoInfo;
        }

        logInformation('getGeoInfo: Last call to getGeoInfo was more than '+nextRandomRetryTimeMinutes+' minutes ago. Calling it');

        // Set the date now to avoid calling this function again
        var dateNow = (new Date()).toISOString();
        geoInfo.queryDate = dateNow;

        extractGeoInfo(geoInfo);

        __geoInfo = geoInfo;
        globalEngine.RegistryStore.set(geoInfoKey, JSON.stringify(__geoInfo));
        //logInformation('getGeoInfo: returning '+JSON.stringify(__geoInfo));

        return __geoInfo;
    }
    catch(e)
    {

        logError('getIp: ' + e.message);
        return {
                'geoid': '[unknown]',
                'isQA': '[unknown]'
        };
    }
}

function ReadFile(path, fileName) 
{
    logDebug("Reading file '" + path + "\\" + fileName + "'");
    try 
    {
        var system = getSystemPlugin();
        var sysver = parseInt(system.GetVersion(), 10);
        var dest = path;
        if (sysver > 1) 
        {
            try 
            {
                dest = system.GetKnownFolder(path);
            }
            catch (e) {
                logError("Could not convert '" + path + "' to a known folder path; continuing with unmodified path");
            }
        }
        // correct for a missing \ if necessary
        if ("\\" != dest.slice(-1)) {
            dest += "\\";
        }
        var data = system.ReadFile(dest + fileName);
        return data;
    }
    catch (e) 
    {
        logError("Failed to read file data '" + fileName + "' " + e.message);
        return null;
    }
}

/*Generate regex string to match the keys to search for in the ini file
*/
function generatePattern(keys){
    var regexpStr = "^(";
    if(keys instanceof Array)
    {
        for(var key in keys)
        {
            regexpStr +=keys[key] + "|";
        }
        regexpStr = regexpStr.slice(0,-1); //remove last of |
    }else
    {
        regexpStr +=keys;
    }
    regexpStr+=")[=]";
    return regexpStr;
}

//Used to parse ini files with elements separated by newlines
function GetKeyValueFromINIFile(params) 
{
    //params -> params['path'],params['filename'],params['key']
    try
    {
        var patternStr = generatePattern(params['key']);
        var pattern = new RegExp(patternStr,'gi');
        var iniFile = ReadFile(params['path'], params['filename']);
        var content = iniFile.split("\n");
        var output = {};
        for (var line in content) 
        {
            var patternFound = pattern.exec(content[line]);
            if (patternFound) 
            {
                var result = content[line].split("=");
                //logInformation("GetKeyValueFromINIFile: result: "+JSON.stringify(result));
                if (result.length == 2) 
                {
                    output[patternFound[1]] = result[1].replace(/[\n\r]/g, '');
                }
                pattern = new RegExp(patternStr,'gi'); //Find next key (if key is an array)
            }
        }
        return output;
    }catch(e)
    {
        logError("GetKeyValueFromINIFile: Failed due to ("+JSON.string(params['key'])+") "+e.message);
    }
    return {};
}


function CreateRegistryStore(hivePath)
{
    if(enableAnalyticsSDKForUWP)
    {
        var uwp_storage = ModuleManager.getSingleton("uwp_storage");
        return  uwp_storage;
    }
    var RegistryStore = 
    {
        "hivePath": hivePath,
        "get" : function(name, obfuscated)
        {
            try
            {
                obfuscated = (obfuscated == undefined) ? true : obfuscated;
                var registry = this._getRegistryPlugin(false);
                if(!registry)
                { // Errors already logged
                    return null;
                }
                return registry.queryValue(name, obfuscated);
            }
            catch(e)
            {
                this._logError('get: ' + e.message);
            }
        },
        "set" : function(name, value, obfuscated)
        {
            try
            {
                obfuscated = (obfuscated == undefined) ? true : obfuscated;
                var registry = this._getRegistryPlugin(true);
                if(!registry)
                { // Errors already logged
                    return false;
                }

                if (!registry.setValue(name, value, obfuscated))
                {
                    this._logError("Could not set new value for " + name);
                    return false;
                }
                return true;
            }
            catch(e)
            {
                this._logError('set: ' + e.message);
            }
        },
        "_getRegistryPlugin": function(create)
        {
            if(!this.hivePath)
            {
                this._logError("Hive path not specified");
                return null;
            }
            var registry = ModuleManager.getSingleton("registry");
            if(!registry.openKey(this.hivePath, create))
            {
                this._logError("Could not open hive " + this.hivePath);
                return null;
            }

            return registry;
        },
        "_logInfo": function(msg) { logInformation('RegistryStore:'+ msg); },
        "_logError": function(msg) { logError('RegistryStore:'+ msg); }
    };
    return RegistryStore;
}

/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

export {GetEngineProperty, dateToMfeString, findObjectSize, GetEngineSetting , CreateRegistryStore , getSystemPlugin, isFirstFileVersionGreater, getGeoInfo, isoDateToDate, dataManipulator, GetKeyValueFromINIFile};

// #ENDIF WebPack
